/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type NetworkPathSchemaStrength = typeof NetworkPathSchemaStrength[keyof typeof NetworkPathSchemaStrength] | null;


export const NetworkPathSchemaStrength = {
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;
